// src/services/webSocketService.js
class WebSocketService {
    constructor(url) {
      this.url = url;
      this.ws = null;
      this.reconnectInterval = 5000000; // 自动重连时间
    }
  
    connect() {
      this.ws = new WebSocket(this.url);
  
      this.ws.onopen = () => console.log('WebSocket 连接成功');
      this.ws.onclose = () => this.handleReconnect();
      this.ws.onerror = (error) => {
        console.error('WebSocket 连接错误:', error);
        this.ws.close();
      };
    }
  
    handleReconnect() {
      console.log('WebSocket 断开连接，尝试重连...');
      setTimeout(() => this.connect(), this.reconnectInterval);
    }
  
    send(data) {
      if (this.ws && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify(data));
      }
    }
  
    disconnect(id) {
   // 假设 user_id 是要断开的用户 ID

const forceDisconnectUrl = `http://123.60.38.210:5000/api/force-disconnect/${id}`;

fetch(forceDisconnectUrl, {
  method: 'get', // 或者使用 'GET'，取决于后端接口的实现
  headers: {
    'Content-Type': 'application/json',
  },
   // 如果需要传递额外信息
})
  .then(response => response.json())
  .then(data => {
    console.log('强制断开连接成功:', data);
  })
  .catch(error => {
    console.error('强制断开连接失败:', error);
  });
    }
  }
  
  export default WebSocketService;